'use strict';

angular.module('ecrd.queries')
    .controller('queriesListClosedController', ['$log', 'ShareCrfApiErrorCodes', 'QueriesListUtilities', 'TableItems', 'gettextCatalog', 'CrdConfigurationService', function($log, ShareCrfApiErrorCodes, QueriesListUtilities, TableItems, gettextCatalog, CrdConfigurationService) {
        var vm = this;

        vm.error = false;

        vm.queries = [];
        vm.labelSingular = CrdConfigurationService.getLabelSingular();

        vm.table = {
            loading: true,
            error: false,
            count: 0,
            offset: 0,
            limit: TableItems.getSelectedOption('queries'),
            currentPage: 0,
            orderBy: 'durationOpen',
            orderReverse: true,
            filters: {
                recordUid: '',
                siteCode: undefined,
                type: '',
                status: 'closed',
                creatorName: '',
                text: '',
                field: null,
            },
        };

        vm.$onInit = function() {};

        vm.listQueries = function() {
            vm.table.loading = true;
            vm.table.error = false;

            var params = QueriesListUtilities.parseTableSettings(vm.table);

            return QueriesListUtilities.list(params)
                .then(function(queriesData) {
                    vm.queries = queriesData.rows;
                    vm.table.count = queriesData.count;

                    vm.table.loading = false;
                })
                .catch(function(error) {
                    $log.error(error, 'get closed queries');
                    vm.error = ShareCrfApiErrorCodes.getHumanReadableMessage(error);

                    vm.table.loading = false;
                    vm.table.error = true;
                });
        };

        vm.fieldSelectorVisible = false;
        vm.openFieldSelector = function() {
            vm.fieldSelectorVisible = true;
        };
        vm.closeFieldSelector = function() {
            vm.fieldSelectorVisible = false;
        };
        vm.toogleFieldSelector = function() {
            vm.fieldSelectorVisible = !vm.fieldSelectorVisible;
        };
        vm.clearFieldSelector = function() {
            vm.table.filters.field = null;
            vm.closeFieldSelector();
            vm.listQueries();
        };
        vm.selectField = function(field) {
            vm.table.filters.field = field;
            vm.closeFieldSelector();
            vm.listQueries();
        };

        vm.redirectToRecord = function(recordId, fieldUId) {
            vm.main.redirectToRecord({
                recordId: recordId,
                target: fieldUId,
            });
        };

        vm.getQuerySummary = QueriesListUtilities.buildSummary;

        vm.downloading = false;
        vm.downloadExcel = function() {
            vm.downloading = true;
            vm.error = false;

            var columns = [
                {
                    id: 'recordUid',
                    header: CrdConfigurationService.getLabelSingular(),
                    type: 'string',
                },
                {
                    id: 'fieldLabel',
                    header: gettextCatalog.getString('Campo'),
                    formatter: function(value) {
                        return angular.isArray(value) ? value.join(' / ') : '';
                    },
                    type: 'string',
                },
                {
                    id: 'text',
                    header: gettextCatalog.getString('Descripción'),
                    formatter: QueriesListUtilities.buildFullSummary,
                    type: 'string',
                },
                {
                    id: 'creatorFullname',
                    header: gettextCatalog.getString('Started By'),
                    type: 'string',
                },
                {
                    id: 'fieldValue',
                    header: gettextCatalog.getString('Valor'),
                    formatter: QueriesListUtilities.formatValue,
                    type: 'string',
                },
                {
                    id: 'daysSinceOpened',
                    header: gettextCatalog.getString('Días abierta'),
                    type: 'number',
                },
            ];
            var title = gettextCatalog.getString('Notas de discrepancia cerradas');

            return QueriesListUtilities.downloadExcel(vm.table, columns, title)
                .catch(function(error) {
                    $log.error(error);
                    vm.error = ShareCrfApiErrorCodes.getHumanReadableMessage(error);
                })
                .finally(function() {
                    vm.downloading = false;
                });
        };

        vm.getFieldType = QueriesListUtilities.getFieldType;
    }]);
